import React from 'react';
import { Link } from 'react-router-dom';
import Counter from '../../components/common/Counter';
import { useSite } from '../../context/SiteContext';

export default function TuThuocChoEmPage() {
  const { settings } = useSite();

  const tuThuocCount = parseInt(String(settings.csr_tu_thuoc || 425).replace(/\D/g, '')) || 425;
  const diemTruongCount = parseInt(String(settings.csr_diem_truong || 425).replace(/\D/g, '')) || 425;
  const emNhoCount = parseInt(String(settings.csr_em_nho || 23671).replace(/\D/g, '')) || 23671;

  return (
    <div>
      <section
        className="hero"
        style={{
          background: 'radial-gradient(60% 70% at 80% 0%,rgba(114,191,68,.22),transparent 60%),linear-gradient(180deg,#f6fbef,#fff)'
        }}
      >
        <div className="container hero__inner">
          <div className="reveal">
            <span className="hero__tag">
              <span className="dot" /> Chương trình thiện nguyện 2026
            </span>
            <h1>
              Ngàn tủ thuốc —
              <br />
              <span className="script">Triệu trái tim.</span>
            </h1>
            <p className="hero__lead">
              "Tủ Thuốc Cho Em" là chương trình CSR của Thế Thảo Pharma — kết nối những tấm lòng hảo tâm với các điểm trường, trạm y tế vùng cao, nơi mỗi viên thuốc đều quý giá.
            </p>
            <div className="hero__actions">
              <a className="btn btn--ghost" href="#story">
                Xem câu chuyện
              </a>
            </div>
            <div className="hero__stats">
              <div className="stat">
                <strong><Counter end={tuThuocCount} /></strong>
                <span className="stat-label">Tủ thuốc đã trao</span>
              </div>
              <div className="stat">
                <strong><Counter end={diemTruongCount} /></strong>
                <span className="stat-label">Điểm trường</span>
              </div>
              <div className="stat">
                <strong><Counter end={emNhoCount} /></strong>
                <span className="stat-label">Em nhỏ tiếp cận y tế</span>
              </div>
            </div>
          </div>
          <div className="hero__art reveal" aria-hidden="true">
            <div className="ring ring--1" />
            <div className="ring ring--2" style={{ borderColor: 'rgba(253,185,19,.15)' }} />
            <div className="ring ring--3" />
            <div className="center" style={{ overflow: 'hidden' }}>
              <img
                src="/assets/img/csr-kids.jpg"
                alt="Các em nhỏ vùng cao bên tủ thuốc Thế Thảo"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <div className="pill pill--a">{settings.csr_tu_thuoc || '425'} tủ thuốc đã trao</div>
            <div className="pill pill--b">{settings.csr_diem_truong || '425'} điểm trường</div>
          </div>
        </div>
      </section>

      {/* Sứ mệnh & Lý do */}
      <section id="story" className="section">
        <div className="container about-grid">
          <div className="about-grid__art reveal">
            <img
              src="/assets/img/csr-classroom.jpg"
              alt="Cô và em nhỏ trong lớp học vùng cao"
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <div className="badge">
              <strong>2024</strong>
              <span>Khởi xướng dự án</span>
            </div>
          </div>
          <div className="reveal">
            <span className="eyebrow">Lý do hình thành dự án</span>
            <h2>Bắt đầu từ những chuyến đi thiện nguyện thực tế</h2>
            <p>
              Dự án “Tủ thuốc cho em” được ra đời từ những chuyến đi thiện nguyện thực tế đến các điểm trường vùng sâu vùng xa — nơi mỗi bước chân của thầy cô và học trò là một hành trình vượt núi, băng rừng để tìm đến con chữ. Ở đó, có những em nhỏ lội bộ hàng cây số đến lớp; những vết thương nhỏ, những căn bệnh ngoài da tưởng chừng đơn giản lại trở thành nỗi ám ảnh hằng ngày.
            </p>
            <p>
              Hình ảnh các thầy cô giáo thầm lặng hy sinh — phải bỏ lớp đi hàng chục cây số chỉ để xin vài viên thuốc cho học trò — khiến bất kỳ ai chứng kiến cũng không thể cầm lòng. Chính điều đó, cùng tâm huyết của người làm trong ngành y dược, đã thôi thúc chị <strong>Nguyễn Thu Thảo</strong> cùng cộng sự khởi xướng dự án “Tủ thuốc cho em” — <em>Ngàn tủ thuốc, triệu trái tim</em>.
            </p>
            <p>
              “Tủ thuốc cho em” ra đời như một lời gửi gắm giản dị mà thiết thực: một viên thuốc, một miếng băng, một sự quan tâm đúng lúc cũng có thể xoa dịu nỗi đau, bảo vệ nụ cười trẻ thơ. Mỗi chiếc tủ được đặt đúng nơi là bớt đi một nỗi lo — bắt đầu từ lớp học, lan rộng đến từng mái nhà, từng bản làng xa xôi.
            </p>
            <div className="mission-grid mission-grid--2">
              <div className="mission-card reveal">
                <h4>Tầm nhìn</h4>
                <p>
                  Trao tặng <strong>1.000 tủ thuốc</strong> đến các điểm trường khó khăn trên cả nước (2024–2026), hướng tới mô hình cộng đồng bền vững, tái cấp phát định kỳ.
                </p>
              </div>
              <div className="mission-card reveal">
                <h4>Sứ mệnh</h4>
                <p>
                  Mang y tế cơ bản đến gần hơn với trẻ em vùng sâu, vùng xa; gieo mầm ý thức tự chăm sóc ngay từ lớp học — đồng hành cùng Chương trình Sức khỏe học đường (2021–2025).
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hành trình & Con số */}
      <section className="section section--soft">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '680px', marginInline: 'auto' }}>
            <span className="eyebrow">Hành trình</span>
            <h2>Những dấu chân đã đi qua</h2>
            <p>
              Đó không chỉ là những con số — mà là hành trình của yêu thương. Mỗi chiếc tủ được đặt tại lớp học là một hạt giống của sự quan tâm, là nơi bắt đầu cho hành trình sống khỏe, học khỏe và sống có trách nhiệm.
            </p>
          </div>
          <div className="csr-stats-grid">
            <div className="csr-stat-card reveal">
              <strong><Counter end={tuThuocCount} /></strong>
              <p>Tủ thuốc đã trao</p>
            </div>
            <div className="csr-stat-card reveal">
              <strong><Counter end={diemTruongCount} /></strong>
              <p>Điểm trường</p>
            </div>
            <div className="csr-stat-card reveal">
              <strong><Counter end={emNhoCount} /></strong>
              <p>Em nhỏ tiếp cận y tế</p>
            </div>
            <div className="csr-stat-card reveal">
              <strong><Counter end={1000} /></strong>
              <p>Mục tiêu tủ thuốc 2026</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
